import ChangePassword from "@/views/changepassword/ChangePassword.vue";

export const CHANGE_PASSWORD_ROUTES = [
  {
    path: "/changepassword",
    name: "changepassword",
    component: ChangePassword,
    meta: {
      title: "Alterar Senha",
      header: false,
      footer: false,
      authentication: false,
    },
  },
];
